export default "__VITE_ASSET__DL0Muqf4__"